(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/poy-ranking-list/assets/javascripts/poy-ranking-list.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/poy-ranking-list/assets/javascripts/poy-ranking-list.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState;
const _svs$poker_react$comp = svs.poker_react.components,
  PokerPaper = _svs$poker_react$comp.PokerPaper,
  PoyTableScrollable = _svs$poker_react$comp.PoyTableScrollable;
const _svs$ui$reactForm = svs.ui.reactForm,
  Inputv2 = _svs$ui$reactForm.Inputv2,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Select = _svs$ui$reactForm.Select,
  Option = _svs$ui$reactForm.Option,
  Fieldset = _svs$ui$reactForm.Fieldset;
const _svs$ui = svs.ui,
  IconButton = _svs$ui.ReactIconButton,
  Icon = _svs$ui.ReactIcon;
const _svs$poker_react$data = svs.poker_react.data.poyCurrentRankingConfig,
  header = _svs$poker_react$data.header,
  paragraph = _svs$poker_react$data.paragraph;
const _svs$poker_react$comp2 = svs.poker_react.components.poyRankingList.common,
  fetchRankings = _svs$poker_react$comp2.fetchRankings,
  normalizePlayers = _svs$poker_react$comp2.normalizePlayers,
  Periods = _svs$poker_react$comp2.Periods,
  Tags = _svs$poker_react$comp2.Tags;
const PoyRankingList = () => {
  const _useState = useState(Tags[0].value),
    _useState2 = _slicedToArray(_useState, 2),
    tag = _useState2[0],
    setTag = _useState2[1];
  const _useState3 = useState(Periods[0].value),
    _useState4 = _slicedToArray(_useState3, 2),
    period = _useState4[0],
    setPeriod = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    searchString = _useState6[0],
    setSearchString = _useState6[1];
  const _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    lastSearch = _useState8[0],
    setLastSearch = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isNameSearch = _useState0[0],
    setIsNameSearch = _useState0[1];
  const _useState1 = useState(normalizePlayers(svs.poker_react.data.rankingData.rankingList)),
    _useState10 = _slicedToArray(_useState1, 2),
    playerList = _useState10[0],
    setPlayerList = _useState10[1];
  const _useState11 = useState(svs.poker_react.data.rankingData.numberOfPlayers),
    _useState12 = _slicedToArray(_useState11, 2),
    numberOfPlayers = _useState12[0],
    setNumberOfPlayers = _useState12[1];
  const _useState13 = useState(svs.poker_react.data.rankingData.lastUpdated),
    _useState14 = _slicedToArray(_useState13, 2),
    lastUpdated = _useState14[0],
    setLastUpdated = _useState14[1];
  const fetchData = async _ref => {
    let period = _ref.period,
      searchString = _ref.searchString,
      tag = _ref.tag;
    const response = await fetchRankings({
      period,
      searchString,
      tag
    });
    setLastUpdated(response.lastUpdated);
    setPlayerList(response.players);
    setNumberOfPlayers(response.totalPlayerCount);
    setIsNameSearch(response.isNameSearch);
    setLastSearch(searchString);
  };
  return React.createElement("section", {
    className: "f-content poy-ranking-list-container"
  }, React.createElement("h2", {
    id: "poy-ranking-header"
  }, header ? header : 'Player of the Year-rankningen'), React.createElement("p", null, paragraph), React.createElement(PokerPaper, null, React.createElement(Fieldset, {
    className: "grid-row gutter-xs-1 poker-poy-form-controls"
  }, React.createElement(ControlGroup, {
    className: "col-md-6",
    v2: true
  }, React.createElement(Select, {
    id: "tag",
    inverted: true,
    label: "Rankinglista",
    onChange: e => {
      setSearchString('');
      setTag(e.target.value);
      fetchData({
        period,
        searchString,
        tag: e.target.value
      });
    },
    v2: true,
    value: tag
  }, Tags.map(_ref2 => {
    let label = _ref2.label,
      value = _ref2.value,
      ariaLabel = _ref2.ariaLabel;
    return React.createElement(Option, {
      "aria-label": ariaLabel,
      key: value,
      value: value
    }, label);
  }))), React.createElement(ControlGroup, {
    className: "col-md-6",
    v2: true
  }, React.createElement(Select, {
    id: "period",
    inverted: true,
    label: "Period",
    onChange: e => {
      setSearchString('');
      setPeriod(e.target.value);
      fetchData({
        period: e.target.value,
        searchString,
        tag
      });
    },
    v2: true,
    value: period
  }, Periods.map(_ref3 => {
    let label = _ref3.label,
      value = _ref3.value;
    return React.createElement(Option, {
      key: value,
      value: value
    }, label);
  }))), React.createElement(ControlGroup, {
    className: "col-md-6 poy-search-input",
    v2: true
  }, React.createElement(Inputv2, {
    id: "qs",
    inputHelpText: "S\xF6k p\xE5 ett pokeralias",
    inverted: true,
    label: "S\xF6k",
    onChange: e => {
      if (e.target.value === '' && isNameSearch) {
        fetchData({
          period,
          searchString: e.target.value,
          tag
        });
      }
      setSearchString(e.target.value);
    },
    onKeyUp: e => {
      if (e.keyCode === 13 && searchString.length) {
        fetchData({
          period,
          searchString: e.target.value,
          tag
        });
      }
    },
    type: "text",
    value: searchString
  }), React.createElement(IconButton, {
    className: "poy-search-btn",
    onClick: () => {
      if (searchString.length) {
        fetchData({
          period,
          searchString,
          tag
        });
      }
    }
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "search",
    size: "300"
  })))), React.createElement(PoyTableScrollable, {
    isNameSearch: isNameSearch,
    numberOfPlayers: numberOfPlayers,
    playerList: playerList,
    searchString: lastSearch
  }), lastUpdated && React.createElement("span", null, "Uppdaterad: ".concat(lastUpdated))));
};
setGlobal('svs.poker_react.components.poyRankingList.PoyRankingList', PoyRankingList);

 })(window);